/*!
 * Stimpack Control - Query build
 *
 * @version : 1.0.0
 * @author  : Matthias Courville
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';

(function($) {

    var spControlQueryBuilder = function(el, options)
    {
        var _this = this,
            root = $(el);

        this.options = $.extend({
            'name'          : '',
            'ruleTemplate'  : '',
            'groupTemplate' : '',
            'selectors'     : {
                'rule'              : '.sp-control-query-builder-rule',
                'group'             : '.sp-control-query-builder-group'
            }
        }, options);

        this.el = {
            root : root,
        };

        //this.init();

        console.log('spControlQueryBuilder', this.options);

        this.refresh();
    };

    /*
     *
     */
    spControlQueryBuilder.prototype.refresh = function()
    {
        var _this = this;

        this.el.root.find('.sp-control-query-builder-group').each(function() {
            _this.refreshGroup($(this));
        });

        console.log(this.getValue());
        this.updateJsonOutput(this.getValue());
    }

    /*
     *
     */
    spControlQueryBuilder.prototype.init = function()
    {
        var _this = this;

        this.el.root.on('change', 'select', function(e) {
            _this.refresh();
        });
    };


    /*
     * Get Terms
     */
    spControlQueryBuilder.prototype.getValue = function()
    {
        var container = this.el.root.find('.sp-control-query-builder-parameters'),
            json = container.find('select, input').serializeJSON({useIntKeysAsArrayIndex: false});

        if (typeof json === 'object')
        {
            if (typeof json[this.options.name] === 'object')
            {
                json = json[this.options.name];
            }
            else if (typeof json.acf === 'object')
            {
                json = json.acf;
                json = json[Object.keys(json)[0]];
            }

            return json;
        }
    };

    /*
     * Update json input
     */
    spControlQueryBuilder.prototype.updateJsonOutput = function(value)
    {
        var input = this.el.root.find('.sp-control-query-builder-encoded-output');

        value = typeof value === 'object' ? spBase64Encode(JSON.stringify(value)) : null;

        this.el.root.find('.sp-control-query-builder-encoded-output').val(value);
    }

    $.fn.spControlQueryBuilder = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-query-builder');

            $(this).attr('data-sp-control-query-builder', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlQueryBuilder = new spControlQueryBuilder(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-query-builder]').each(function() {
        $(this).spControlQueryBuilder();
    });


})(jQuery);
